import type { HttpInterceptorFn } from '@angular/common/http';
import type { EnvironmentProviders, Type } from '@angular/core';
import type { Route } from '@angular/router';

import { DEV_SCENARIOS } from '@arya/dev-demo/scenarios';
import { DEMO_OUTBOX_HEADER } from '@arya/shared/dev-accounts';

import {
  demoOutboxInterceptor,
  NoxoDemoOverlay,
  provideDemoCodeAssist,
  provideScenarioConsole,
} from '@noxo/demo/feature';
import { provideNoxoPlaceholders } from '@noxo/ui/placeholder';

export const DEV_SURFACE_ROUTES: Route[] = [
  {
    path: 'showcase',
    loadChildren: () => import('@arya/showcase/feature').then((m) => m.SHOWCASE_ROUTES),
  },
];

export const DEV_OVERLAY_COMPONENT: Type<unknown> | undefined = NoxoDemoOverlay;

export const DEV_SURFACE_PROVIDERS: EnvironmentProviders[] = [
  provideScenarioConsole(DEV_SCENARIOS),
  provideDemoCodeAssist(),
  provideNoxoPlaceholders(),
];

export const DEV_HTTP_INTERCEPTORS: HttpInterceptorFn[] = [demoOutboxInterceptor];

export const DEV_TRANSFER_CACHE_HEADERS: string[] = [DEMO_OUTBOX_HEADER];
